import { BaseMetricsService } from '~/passporter-services/shared/metrics'
import { RouteName } from './route/types'
import { RouteService } from './route/service'

export class MetricsService implements BaseMetricsService {
	private static instance: MetricsService
	private constructor() {}
	private client = 'passporter'

	public static getInstance(): MetricsService {
		if (!this.instance) this.instance = new MetricsService()
		return this.instance
	}

	getClientName() {
		return this.client
	}

	getContext(routeName: string): string | undefined {
		const context: Record<RouteName, string> = {
			'profile': 'profile',
			'profile-wished': 'profile',
			'profile-visited': 'profile',
			'home': 'home',
			'explore': 'explore',
			'destinations-destination-destination_id': 'microsite',
			'destinations-country-destination-destination_id': 'microsite',
			'trip-create': 'wizard',
			'trip-itinerary_id-tasks': 'planner',
			'trip-itinerary_id-spots': 'planner',
			'trip-itinerary_id-dashboard': 'planner',
			'trip-itinerary_id-itinerary': 'planner',
			'trip-itinerary_id-documents': 'planner',
			'trip-itinerary_id-store': 'planner',
			'trip-itinerary_id-store-ideas': 'planner',
			'trip-itinerary_id-store-ideas-product_id': 'planner',
			'trip-itinerary_id-store-activities': 'planner',
			'trip-itinerary_id-store-activities-product_id': 'planner',
			'trip-itinerary_id-store-indispensables': 'planner',
			'trip-itinerary_id-wall': 'planner',
			'docs': 'planner',
			'auth-login': 'signup',
			'my-trips': 'trips',
			'auth-signup': 'signup',
		}
		const normalizedRouteName = RouteService.getNormalizedRouteName(routeName)

		return context[normalizedRouteName]
	}
}
